module.exports = __webpack_public_path__ + "img/sinerlog.4cf67cd7.png";